module.exports = __webpack_public_path__ + "static/media/Payroll.bfdbd88e.png";